<script>
import Base from './base.vue';
import BaseNext from './base-next.vue';
import autoAdd from '../mixin/auto-add';
import { pageConfig } from '@/common/service/page-config';

const isPreviousCase = !!pageConfig.init_categories;

export default {
  name: 'BUY_NOW',
  extends: isPreviousCase ? BaseNext : Base,
  mixins: [autoAdd],
};
</script>
